import React from 'react'

export const Comments = ({data}:any) => {
    return (
        <div className="col-sm-12 card p-5 mt-5">
            <form >
                <div className="form-row">
                    <div >
                        <h4>Comments</h4>
                    </div>
                    <div className=" col-md-12  ">
                      {data && data.length>0 ? data.map((el:any)=><h6>{el.text? el.text:el}</h6>) : "No Comments Available"}
                    </div>
                </div>
            </form>

        </div>
    )
}
